import React from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import TopBanner from './TopBanner';
import GlobalStyles from './GlobalStyles'; // Correct import path

const Layout = ({ children }) => {
  return (
    <>
      <GlobalStyles />
      <Box sx={{ 
        display: 'flex',
        height: '100vh',
        overflow: 'hidden'
      }}>
        <TopBanner />
        <Sidebar />
        <Box component="main" sx={{
          flex: 1,
          ml: '72px',
          overflow: 'hidden',
          pt: '64px',
          display: 'flex'
        }}>
          {children}
        </Box>
      </Box>
    </>
  );
};

export default Layout;